import React from 'react'

import { styled } from 'design'

import { container, truncate } from './shared'

export const Box = styled('div', {
  display: 'flex',
  flex: 'none',
  alignItems: 'center',
  justifyContent: 'center',
  ...container,
  variants: {
    truncate: {
      true: {
        ...truncate,
      },
    },
  },
})

export type BoxProps = React.ComponentProps<typeof Box>

Box.displayName = 'Box'
